/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Date_TimeInputs */

const en_ticket_date_time = /** @type {(inputs: Ticket_Date_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date & Time`)
};

const ja_ticket_date_time = /** @type {(inputs: Ticket_Date_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日時`)
};

const fr_ticket_date_time = /** @type {(inputs: Ticket_Date_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date et heure`)
};

const de_ticket_date_time = /** @type {(inputs: Ticket_Date_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum & Uhrzeit`)
};

/**
* | output |
* | --- |
* | "Date & Time" |
*
* @param {Ticket_Date_TimeInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_date_time = /** @type {((inputs?: Ticket_Date_TimeInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Date_TimeInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_date_time(inputs)
	if (locale === "ja") return ja_ticket_date_time(inputs)
	if (locale === "fr") return fr_ticket_date_time(inputs)
	return de_ticket_date_time(inputs)
});